import React from 'react';
import { OverlayComponent } from 'app/components';
import { hasTranslationsValid } from 'app/components/translation/has-translations-valid';
import { validateExternalUrl } from '../utils/validate-external-url';
import { ExternalUrlContainerProps } from '../types';
import { ExternalUrlStickyHeader } from './external-url-sticky-header';

export const ExternalUrlContainer: React.FC<ExternalUrlContainerProps> = ({
  actionType, formState, shouldPrompt, mainLanguage, translation, children,
  switchTranslationsToggle, saveExternalUrl,
  deleteExternalUrl, updateValidation, displayError
}) => {

  const { externalUrlItem, fetching, saving, deleting, languageOptions, validation } = formState;

  const onSave = () => {
    const formValidation = validateExternalUrl(actionType, externalUrlItem, languageOptions, translation);

    updateValidation({ ...validation, ...formValidation });

    if (Object.keys(formValidation).length > 0) {
      !hasTranslationsValid(formValidation.language, mainLanguage) && switchTranslationsToggle(true);
      displayError(translation.external_url_validation_error);
      return;
    }

    saveExternalUrl(externalUrlItem);
  };

  const externalUrlName = externalUrlItem.language
    ?.find(languageItem => languageItem.value === mainLanguage)
    ?.description;

  return <>
    <OverlayComponent
      displayOverlay={saving || deleting}
      overlayText={saving
        ? translation.saving_external_url
        : translation.deleting_external_url} />
    <ExternalUrlStickyHeader
      actionType={actionType}
      shouldPrompt={shouldPrompt}
      externalUrlItem={externalUrlItem}
      name={externalUrlName}
      fetching={fetching}
      displayError={displayError}
      onSave={onSave}
      onDelete={deleteExternalUrl}
      translation={translation} />
    {children}
  </>;
};
